"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customSimpleSelect = void 0;
const mapbox_gl_draw_1 = __importDefault(require("@mapbox/mapbox-gl-draw"));
const constants_1 = require("@mapbox/mapbox-gl-draw/src/constants");
const FabricDrawingModes_1 = require("../FabricDrawingModes");
// Much of this borrowed from here:
// https://github.com/zakjan/mapbox-gl-draw-waypoint/blob/master/src/modes/simple_select.js
const { simple_select } = mapbox_gl_draw_1.default.modes;
const customSimpleSelect = (preventDrag = false) => {
    // If we're not preventing dragging, just pass through the untouched SimpleSelect
    if (!preventDrag)
        return simple_select;
    const CustomSimpleSelect = Object.assign({}, simple_select);
    // Override clickOnFeature if we want to prevent drag
    CustomSimpleSelect.clickOnFeature = function (state, e) {
        if (e.featureTarget.geometry.type !== constants_1.geojsonTypes.POINT) {
            this.changeMode(FabricDrawingModes_1.DrawingMode.DIRECT_SELECT, {
                featureId: e.featureTarget.properties.id,
            });
        }
        else {
            simple_select.clickOnFeature.call(this, state, e);
            // prevent multi selection for consistency with direct_select mode
            this.setSelected(e.featureTarget.properties.id);
        }
    };
    return CustomSimpleSelect;
};
exports.customSimpleSelect = customSimpleSelect;
exports.default = exports.customSimpleSelect;
